module.exports = __webpack_public_path__ + "img/signin1.999b022d.png";